import { twMerge } from "tailwind-merge"

export const Article = ({ children, className, style, bgColor }) => {

    return (
        <article 
            className={twMerge(`${bgColor && bgColor}`, className)}
            style={style}
        >
            { children }
        </article>
    )
}